export const formatCheckoutPrice = (price: number) =>
  new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 2 }).format(price);
